import { render, staticRenderFns } from "./AddTdsCertificate.vue?vue&type=template&id=5e2c66a3"
import script from "./AddTdsCertificate.vue?vue&type=script&lang=js"
export * from "./AddTdsCertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports